module.exports = "/_next/static/files/af30f07a6ab26e3f1a2b8f708310eaa6.svg";